import Vue from 'vue'
import App from './App.vue'
import H5App from './h5/index.vue'
import router from './router'
import './utils/element'
import * as api from './utils/api'
import utils from './utils/utils'
import store from './store/index'
import Print from 'vue-print-nb'
Vue.use(Print);

const arr = {
  api: api.default,
  utils
}
for (const key in arr) {
  Object.defineProperty(Vue.prototype, `$${key}`, {
    get: () => arr[key]
  })
}

require('./assets/css/tools.css')
require('./assets/css/common.css')
require('./assets/css/iconfont.css')

Vue.config.productionTip = false

router.afterEach(() => {
  window.scrollTo(0, 0)
})
const ua = navigator.userAgent.toLowerCase();
const isH5 = /iphone|ipad|ipod|android|mobile/i.test(ua);
const app = isH5 ? H5App : App;
new Vue({
  router,
  store,
  render: h => h(app),
}).$mount('#app')
